import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "./context/LangContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import HomePage from "./pages/HomePage";
import AgentPage from "./pages/AgentPage";
import SecteursPage from "./pages/SecteursPage";
import TarifsPage from "./pages/TarifsPage";
import ContactPage from "./pages/ContactPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <LangProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/agent" element={<AgentPage />} />
            <Route path="/secteurs" element={<SecteursPage />} />
            <Route path="/tarifs" element={<TarifsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/confidentialite" element={<ConfidentialitePage />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </LangProvider>
  );
}

export default App;
